import {
  LogicalOperator,
  SearchOperator,
  type SearchCriteria,
  type SearchQueryRequest,
} from "@/openapi/generated";

export function buildNameSearchQuery(
  q: string,
  fieldPrefix?: string,
): SearchQueryRequest & { criteria: SearchCriteria[] } {
  const firstNameField = fieldPrefix ? `${fieldPrefix}.FirstName` : "FirstName";
  const lastNameField = fieldPrefix ? `${fieldPrefix}.LastName` : "LastName";
  const parts = q.split(/\s+/).filter(Boolean);

  if (parts.length >= 2) {
    return {
      criteria: [
        { field: firstNameField, operator: SearchOperator.Contains, value: parts[0] },
        {
          field: lastNameField,
          operator: SearchOperator.Contains,
          value: parts.slice(1).join(" "),
          logicalOperator: LogicalOperator.And,
        },
      ],
    };
  }

  return {
    criteria: [
      { field: firstNameField, operator: SearchOperator.Contains, value: q },
      {
        field: lastNameField,
        operator: SearchOperator.Contains,
        value: q,
        logicalOperator: LogicalOperator.Or,
      },
    ],
  };
}
